import { defineRule, configure } from 'vee-validate'
import { required, email } from '@vee-validate/rules'

export default defineNuxtPlugin(({ $i18n }) => {
  configure({
    generateMessage: ({ rule }) => ($i18n as any).t(`errors.${rule?.name}`),
  })

  defineRule('required', required)
  defineRule('email', email)
  defineRule(
    'length',
    (val: any[], options: [number]) => unref(val).length >= options[0] * 1,
  )
})
